import React from 'react'
import {IconProps} from '../../types/IconProps'

const AlignerChangeIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.63878 15.0132L8.33459 16.709L8.33582 16.7103L8.33581 16.7103C8.53599 16.9175 8.536 17.2461 8.33581 17.4533C8.33581 17.4533 8.33581 17.4533 8.33581 17.4533L8.26388 17.3839L6.63878 15.0132ZM6.63878 15.0132H12.3043C12.5997 15.0132 12.8391 14.7738 12.8391 14.4784C12.8391 14.183 12.5996 13.9437 12.3043 13.9437H6.63873L6.63878 15.0132Z'
        fill={color || 'black'}
        stroke={color || 'black'}
        strokeWidth='0.2'
      />
      <path
        d='M14.4215 4.53523L14.4215 4.53525L17.0302 7.14399L17.0302 7.144C17.2389 7.35286 17.239 7.69137 17.0302 7.90019L17.0302 7.9002L14.4221 10.5083C14.418 10.5125 14.4138 10.5167 14.4096 10.5208L14.4095 10.5208C14.1971 10.7259 13.8585 10.7202 13.6533 10.5077C13.4484 10.2954 13.4541 9.95737 13.6658 9.7521L15.3611 8.05687H9.69554C9.40019 8.05687 9.16074 7.81742 9.16074 7.52207C9.16074 7.22672 9.40019 6.98728 9.69554 6.98728H15.3611L13.6653 5.29146L13.664 5.29024L13.664 5.29023L14.4215 4.53523ZM14.4215 4.53523L14.4202 4.53403C14.2078 4.32882 13.8692 4.33469 13.664 4.54716L14.4215 4.53523Z'
        fill={color || 'black'}
        stroke={color || 'black'}
        strokeWidth='0.2'
      />
      <path
        d='M11 0.9C5.43043 0.9 0.9 5.43088 0.9 11C0.9 16.5691 5.43043 21.1 11 21.1C16.5696 21.1 21.1 16.5691 21.1 11C21.1 5.43088 16.5696 0.9 11 0.9ZM11 20.0304C6.02088 20.0304 1.96955 15.9796 1.96955 11C1.96955 6.02044 6.02088 1.96955 11 1.96955C15.9791 1.96955 20.0304 6.02044 20.0304 11C20.0304 15.9796 15.9792 20.0304 11 20.0304Z'
        fill={color || 'black'}
        stroke={color || 'black'}
        strokeWidth='0.2'
      />
    </svg>
  )
}

export default AlignerChangeIcon
